import { render } from "./TextareaAutosize.vue?vue&type=template&id=0bcd1bb6"
import script from "./TextareaAutosize.vue?vue&type=script&lang=js"
export * from "./TextareaAutosize.vue?vue&type=script&lang=js"
script.render = render

export default script